export function createSelectionStore(Alpine: any) {
  return {
    ids: new Set<string>(),
    lastSelectedID: null as string | null, // For Shift+Click range selection
    version: 0, // Reactivity trigger for Set

    // Core: Toggle ID
    toggle(id: string, isShift: boolean = false, allIdsInOrder: string[] = []) {
      if (isShift && this.lastSelectedID && allIdsInOrder.length > 0) {
        // Range Selection
        const startIdx = allIdsInOrder.indexOf(this.lastSelectedID);
        const endIdx = allIdsInOrder.indexOf(id);

        if (startIdx !== -1 && endIdx !== -1) {
          const [lower, upper] = [Math.min(startIdx, endIdx), Math.max(startIdx, endIdx)];
          const range = allIdsInOrder.slice(lower, upper + 1);

          // Add all in range
          range.forEach((idxID) => this.ids.add(idxID));
        }
      } else {
        // Normal Toggle
        if (this.ids.has(id)) {
          this.ids.delete(id);
          this.lastSelectedID = null;
        } else {
          this.ids.add(id);
          this.lastSelectedID = id;
        }
      }

      this.version++;
    },

    // Select specific array of IDs (e.g., Select All)
    // If all provided IDs are already selected, we deselect them (Toggle behavior)
    selectAll(ids: string[]) {
      const allSelected = ids.every((id) => this.ids.has(id));
      if (allSelected) {
        ids.forEach((id) => this.ids.delete(id));
      } else {
        ids.forEach((id) => this.ids.add(id));
      }
      this.version++;
    },

    // Clear all
    deselectAll() {
      this.ids.clear();
      this.lastSelectedID = null;
      this.version++;
    },

    // Reactivity Helper
    isSelected(id: string) {
      // Depend on version to trigger re-eval
      return this.version >= 0 && this.ids.has(id);
    },

    get count() {
      return this.version >= 0 ? this.ids.size : 0;
    },

    get hasSelection() {
      return this.count > 0;
    },

    // Export as array for API calls
    get array() {
      return Array.from(this.ids);
    },
  };
}
